// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-dialog-content {
  width: 820px;
}
.edit-dialog-content mat-form-field {
  width: 100%;
  word-break: break-all;
}

.edit-dialog-footer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/app/e-form/dialog/edit-dialog/edit-dialog.component.scss"],"names":[],"mappings":"AAAA;EACG,YAAA;AACH;AAAG;EACG,WAAA;EACA,qBAAA;AAEN;;AAGA;EACG,WAAA;EACA,aAAA;EACA,8BAAA;AAAH","sourcesContent":[".edit-dialog-content{\n   width: 820px;\n   mat-form-field  {\n      width: 100%;\n      word-break: break-all;\n   }\n}\n\n\n.edit-dialog-footer {\n   width: 100%;\n   display: flex;\n   justify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
